import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle, Mail, User, X } from 'lucide-react';

const MailCourtierClientsModal = ({
  courtierClients,
  currentPage,
  deselectAllCourtierClients,
  isEmailSelected,
  paginateItems,
  renderPagination,
  selectAllCourtierClients,
  selectContactEmail,
  selectedCourtier,
  setShowCourtierClients
}) => {
  const { t } = useTranslation('admin');
  return (
    <>
        <div data-testid="mail-courtier-clients-modal" className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl max-h-[80vh] flex flex-col">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-slate-200">
              <div>
                <h3 className="text-xl font-bold text-slate-900 flex items-center">
                  <User size={24} className="mr-3 text-blue-600" />
                  {t('mail.clientsOf', { name: selectedCourtier.name })}
                </h3>
                <p className="text-sm text-slate-600 mt-1">
                  {t('mail.clientsFoundSimple', { count: courtierClients.length })}
                </p>
              </div>
              <button
                onClick={() => setShowCourtierClients(false)}
                className="p-2 hover:bg-slate-100 rounded-lg transition-colors"
              >
                <X size={20} />
              </button>
            </div>

            {/* Action Buttons */}
            <div className="px-4 py-3 bg-slate-50 border-b border-slate-200 flex items-center justify-end space-x-2">
              <button
                onClick={selectAllCourtierClients}
                className="px-4 py-1.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors text-sm font-medium flex items-center space-x-2"
              >
                <CheckCircle size={14} />
                <span>{t('mail.selectAll')}</span>
              </button>
              <button
                onClick={deselectAllCourtierClients}
                className="px-4 py-1.5 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300 transition-colors text-sm font-medium"
              >
                {t('mail.deselectAll')}
              </button>
            </div>

            {/* Clients List */}
            <div className="flex-1 overflow-y-auto p-4">
              {courtierClients.length === 0 ? (
                <div className="text-center py-12">
                  <User size={48} className="mx-auto text-slate-300 mb-4" />
                  <p className="text-slate-500">{t('mail.noClientForCourtier')}</p>
                </div>
              ) : (
                <div className="space-y-2">
                  {paginateItems(courtierClients, currentPage.courtierClients).map((client) => (
                    <div key={client.id} className="p-4 bg-slate-50 rounded-xl border border-slate-200 hover:bg-slate-100 transition-colors">
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <p className="font-medium text-slate-900 mb-2">{client.name}</p>
                          <div className="space-y-1">
                            {client.emails.map((email, index) => (
                              <button
                                key={index}
                                onClick={() => {
                                  selectContactEmail(email);
                                }}
                                className={`flex items-center justify-between w-full px-3 py-2 rounded-lg transition-colors ${
                                  isEmailSelected(email)
                                    ? 'bg-green-100 text-green-800 border border-green-300'
                                    : 'bg-white text-indigo-600 hover:bg-indigo-50 border border-slate-200'
                                }`}
                              >
                                <div className="flex items-center space-x-2">
                                  <Mail size={14} />
                                  <span className="text-sm">{email}</span>
                                </div>
                                {isEmailSelected(email) && (
                                  <CheckCircle size={16} className="text-green-600" />
                                )}
                              </button>
                            ))}
                          </div>
                        </div>
                        <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded-lg text-xs font-medium">
                          {t('mail.linkedClient')}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Pagination */}
            {renderPagination('courtierClients', courtierClients.length)}

            {/* Footer */}
            <div className="p-4 border-t border-slate-200">
              <button
                onClick={() => setShowCourtierClients(false)}
                className="w-full px-4 py-2 bg-slate-100 text-slate-700 rounded-xl hover:bg-slate-200 transition-colors"
              >
                {t('mail.back')}
              </button>
            </div>
          </div>
        </div>
    </>
  );
};

export default MailCourtierClientsModal;
